import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRatingInsight = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [ratingInsightData, setRatingInsightData] = useState<any[]>([]);

    const onRatingDataError = (err: AxiosError<ErrorHttpResponse>) => {
        setRatingInsightData([]);
    };

    const onRatingDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<RatingInsightData[]>) => {
        setRatingInsightData(Array.isArray(data) ? data : []);
    };

    const getRatingDataInsight = (urlString: string) => {
        const url: HttpConfig = {
            url: urlString,
            method: 'get',

        };
        request(url, onRatingDataSuccess, setLoading, onRatingDataError);
    };

    return { getRatingDataInsight, loading, ratingInsightData };
};

export default useRatingInsight;


interface RatingInsightData {
    averageRating: number;
    noOfRatings: number;
    period: string;
    periodEnd: string;
    periodStart: string;
    ratingClass: string;
    ratingColor: string | null;
}
